/** CVM code for Petrobras — used by StocksPage to call the live API. */
export const PETROBRAS_CDCVM = 9512;
